import React, { useContext, useEffect, useState } from 'react';
import {
    Button,
    Col,
    Container,
    Form,
    Row,
    Spinner
} from 'react-bootstrap';
import { useNavigate, useParams } from "react-router-dom";

import AuthContext from '../../Context/authContext';
import { setNewPassword } from '../../Services/api';
import Notification, { useNotification } from 'src/Components/Notification';
import './style.scss';

const NewPasswordPage = () => {
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [hasPasswordError, setHasPasswordError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { setIsAdmin } = useContext(AuthContext);
    let { token } = useParams();
    const navigate = useNavigate();
    const { notifySuccess, notifyError, onClose, notification } = useNotification();

    useEffect(() => {
        setIsAdmin(true);
    }, [setIsAdmin]);

    const handleSubmit = async e => {
        setIsLoading(true);
        e.preventDefault();
        const res = await setNewPassword({ new_password: password, token });

        if (res.status !== 200) {
            const errMsg = res.response.data.detail;
            notifyError({ message: errMsg });
        } else {
            notifySuccess({ message: 'Your new password has been set successfully.' });
        }
        setIsLoading(false);
    };

    const validatePassword = (text) => {
        setPassword2(text);

        if (password === text) {
            setHasPasswordError(false);
        } else {
            setHasPasswordError(true);
        }
    };

    return (
        <>
            <Container className='sharedAuthStyles resetContainer'>
                <Notification
                    id="new-password-notif"
                    onClose={() => {
                        onClose();
                        notification.type === "success" && navigate('/login');
                    }}
                    {...notification}
                />
                <div className='header mb-5 mt-5'>
                    <h4 className='text-secondary'>new password</h4>
                    <p className='text-muted'>
                        Enter a new password for your account
                    </p>
                </div>
                <Form onSubmit={handleSubmit}>
                    <Row className='mb-5'>
                        <Col>
                            <Form.Group controlId='formPassword'>
                                <Form.Control
                                    className='formInput text-dark'
                                    type='password'
                                    placeholder='Password'
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className='mb-4'>
                        <Col>
                            <Form.Group controlId='formPassword2'>
                                <Form.Control
                                    className='formInput text-dark'
                                    type='password'
                                    placeholder='Re-type Password'
                                    value={password2}
                                    onChange={(e) => validatePassword(e.target.value)}
                                />
                            </Form.Group>
                            {hasPasswordError && (
                                <p style={{ color: "red", fontSize: 12, marginTop: 5 }}>
                                    Passwords does not match
                                </p>
                            )}
                        </Col>
                    </Row>
                    <div className='text-center'>
                        <Button
                            className='business submitButton mt-5'
                            type='submit'
                            disabled={!(password.length > 0 ) || isLoading}
                        >
                            {isLoading && (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            )}
                            Submit
                        </Button>
                    </div>
                </Form>
            </Container>
        </>
    )
};

export default NewPasswordPage;
